import React from 'react';
import {useTranslation} from 'react-i18next';

const Footer = () => {
    const [t] = useTranslation();

    return (
        <footer className="main-footer">
            <strong>
                <span>By Think Technology © &nbsp;<i className='flag-icon flag-icon-br'></i></span>
            </strong>
            <div className="float-right d-none d-sm-inline-block">
                <b>{t('Footer.Product')}:</b>
                <span>&nbsp;{localStorage.getItem('product')}</span>
                &nbsp;&nbsp;-&nbsp;&nbsp;
                <b>{t('Footer.Version')}:</b>
                <span>&nbsp;{localStorage.getItem('fwVersion')}</span>
            </div>
        </footer>
    );
};

export default Footer;
